import { FeatureCardProps } from "./FeatureCard";

export const FEATURES_DATA: FeatureCardProps[] = [
  {
    icon: "/assets/hero/audited.png",
    title: "Audited & secure",
    description:
      "Multiple audits to thoroughly evaluate the protocol's security & functionality",
  },
  {
    icon: "/assets/hero/utility.png",
    title: "Maximum utility",
    description:
      "rsETH is available on multiple DeFi protocols, DEXs, CEXs, & wallets",
  },
  {
    icon: "/assets/hero/liquidity.png",
    title: "Deep liquidity",
    description: "$300M+ across lending protocols, optimisers, and on-chain",
  },
  {
    icon: "/assets/hero/restaking.png",
    title: "One-click restaking",
    description: "Kelp accepts deposits from major LSTs & ETH",
  },
];
